export default "__VITE_ASSET__504b5eeb__"